const Home = () => import("../views/Home.vue");
import childrenList from "./menuList";
const children = [
  {
    path: "/signUp",
    name: "signUp",
    meta: {
      title: "大赛报名",
      menuPath: "",
    },
    component: () => import("../views/signUp.vue"),
  },
  {
    path: "/userLogin",
    name: "userLogin",
    meta: {
      title: "用户登录",
      menuPath: "",
    },
    component: () => import("../views/userLogin.vue"),
  },
  /**
   *主题详情-平面
   */
  {
    path: "/themeWorks/imageWorkDetail",
    name: "themeWorksImageWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/themeWorks",
    },
    component: () => import("../views/imageWorkDetail.vue"),
  },
  /**
 *我的作品详情-平面
 */
  {
    path: "/myWorks/imageWorkDetail",
    name: "myWorksImageWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/myWorks",
    },
    component: () => import("../views/imageWorkDetail.vue"),
  },
  /**
 *我的作品详情-视频
 */
  {
    path: "/myWorks/videoWorkDetail",
    name: "myWorksVideoWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/myWorks",
    },
    component: () => import("../views/videoWorkDetail.vue"),
  },
  /**
   *自由主题详情-平面
   */ {
    path: "/freeThemeWorks/imageWorkDetail",
    name: "freeThemeWorksImageWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/freeThemeWorks",
    },
    component: () => import("../views/imageWorkDetail.vue"),
  },
  /**
   *主题详情-视频
   */ {
    path: "/themeWorks/videoWorkDetail",
    name: "themeWorksVideoWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/themeWorks",
    },
    component: () => import("../views/videoWorkDetail.vue"),
  },
  /**
   *自由主题详情-视频
   */ {
    path: "/freeThemeWorks/videoWorkDetail",
    name: "freeThemeWorksVideoWorkDetail",
    meta: {
      title: "作品详情",
      menuPath: "/freeThemeWorks",
    },
    component: () => import("../views/videoWorkDetail.vue"),
  },
  //上传作品
  {
    path: "/upLoadFile",
    name: "upLoadFile",
    meta: {
      title: "上传作品",
      menuPath: "/myWorks",
    },
    component: () => import("../views/upLoadFile.vue"),
  },
];
const routerList = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: '/contestDetail',
    meta: {
      keepAlive: false,
    },
    children: [...childrenList, ...children],
  },

  {
    path: '/notfound',
    name: 'notfound',
    component: () => import("../views/NotFound.vue"),

  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/notfound',
  },
];

export default routerList;
